module.exports = __webpack_public_path__ + "fonts/icons.e43e976.woff2";